export default __webpack_public_path__ + "static/media/website.de3b1d0a.png";